import DelayedCall from "./DelayedCall";
import { triggerCustomEvent } from "./EventTrigger";
import addResizeHandler from "./ResizeEventListener";

export default class Accordion
{
    protected controls: NodeListOf<HTMLElement>;
    protected delayedCall: DelayedCall;

    protected classes = {
        opened: 'accordion_opened',
        controlOpened: 'accordion-control_opened',
        openedAfterLoad: 'accordion_opened-after-load',
    }

    constructor(controls: string|NodeListOf<HTMLElement>)
    {
        this.controls = typeof controls === 'string' ? document.querySelectorAll(controls) : controls;
        this.delayedCall = new DelayedCall();
    }

    public init()
    {
        this.appendEventListeners();
    }

    public getControls(): NodeListOf<HTMLElement>
    {
        return this.controls;
    }

    public getBodyForControl(control: HTMLElement): NodeListOf<HTMLElement>
    {
        if (typeof control.dataset.target === 'undefined') {
            return null;
        }

        return document.querySelectorAll(control.dataset.target) as NodeListOf<HTMLElement>;
    }

    public adaptHeight(body: HTMLElement)
    {
        if (body === null) {
            return;
        }

        if (body.classList.contains(this.classes.opened)) {
            body.style.height = 'auto';
            new DelayedCall().execute(this.open, 200, this, body); // normalize height
        }
    }

    public switch(body: HTMLElement)
    {
        if (body === null) {
            return;
        }

        if (body.classList.contains(this.classes.opened)) {
            this.close(body);
        } else {
            this.open(body);
        }
    }

    public setResizeEventListeners()
    {
        let bodies = {};

        this.controls.forEach(control => {
            if (typeof control.dataset.target === 'undefined') {
                return;
            }
            let cBodies = this.getBodyForControl(control);

            cBodies.forEach(body => {
                bodies[control.dataset.target] = body;
            });

            //bodies[control.dataset.target] = this.getBodyForControl(control);
        });

        for (let key in bodies) {
            addResizeHandler(this.adaptHeight, this, bodies[key]);
        }
    }

    public getClassOpened(): string
    {
        return this.classes.opened;
    }

    protected appendEventListeners()
    {
        this.controls.forEach(control => {
            control.addEventListener('click', () => {
                this.switchControl(control);

                let bodies = this.getBodyForControl(control);

                bodies.forEach(body => {
                    this.switch(body);
                });
                
                triggerCustomEvent(control, 'accordion.switch', {
                    detail: {status: control.classList.contains(this.classes.controlOpened) ? 'open' : 'close'}
                });
            });

            if (control.classList.contains(this.classes.openedAfterLoad)) {
                control.click();
            }
        });

        this.setResizeEventListeners();
    }

    public switchControl(control: HTMLElement)
    {
        if (control.classList.contains(this.classes.controlOpened)) {
            control.classList.remove(this.classes.controlOpened);

            if (control.dataset.openText) {
                control.innerText = control.dataset.openText;
            }
        } else {
            control.classList.add(this.classes.controlOpened);

            if (control.dataset.closeText) {
                control.innerText = control.dataset.closeText;
            }
        }
    }

    protected open(body: HTMLElement)
    {
        body.classList.add(this.classes.opened);
        body.style.height = body.scrollHeight + 'px';
        body.style.height = 'auto';
        body.style.visibility = 'visible';

    }

    protected close(body: HTMLElement)
    {
        let minHeight = (body.dataset.minHeight || '0') + 'px';       

        body.style.height = body.scrollHeight + 'px';
        body.classList.remove(this.classes.opened);
        body.style.height = minHeight;
        body.style.visibility = 'hidden';
    }

    public openAllAccordions() 
    {
        this.controls.forEach(control => {
            let bodies = this.getBodyForControl(control);

            bodies.forEach(body => {
                this.open(body);
            });
        });        
    } 

    public closeAllAccordions() 
    {
        this.controls.forEach(control => {
            let bodies = this.getBodyForControl(control);

            bodies.forEach(body => {
                this.close(body);
            });
        });        
    }

    public openAccordionAfterLoad(control: HTMLElement)
    {
        if (!control.classList.contains(this.classes.controlOpened)) {
            //this.switchControl(control);
            //this.switch(this.getBodyForControl(control));
            //this.open(this.getBodyForControl(control));
            //control.click();
        }
    }
}

/**
 * Прокручивает страницу к нужному блоку с аккордионом и раскрываем его
 * 
 * @param nodeIdTpl - регулярное выражение для выборки по ID DOM-элемента
 */
export function expandAccordionByHash(nodeIdTpl: string)
{
    let regexp = new RegExp(nodeIdTpl);

    if (regexp.test(window.location.hash)) {
        let hash    = window.location.hash.replace('#', '');
        let target  = document.querySelector(`[data-expand-target="#${hash}"]`) as HTMLElement;
        let control = (!target || target.id === '') ? null : document.querySelector(`[data-target="#${target.id}"]`) as HTMLElement;

        if (control) {
            let targetRect = target.getBoundingClientRect();

            setTimeout(() => {
                window.scroll({
                    top: window.scrollY + targetRect.top - 100,
                    behavior: 'smooth',
                });
    
                setTimeout(() => {control.click()}, 800);
            }, 300);
        }
    }
}
